import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const JobRecommendationCard = ({ job }) => {
  const navigate = useNavigate();

  const handleApply = () => {
    navigate('/job-search-application');
  };

  const formatPostedDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-warm-sm hover:shadow-warm-md transition-smooth">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
          <Image 
            src={job?.companyLogo} 
            alt={job?.companyLogoAlt}
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-heading font-semibold text-card-foreground mb-1 line-clamp-2">
            {job?.title}
          </h4>
          <p className="text-sm text-muted-foreground line-clamp-1">{job?.company}</p>
        </div>

        {job?.isNew && (
          <span className="px-2 py-1 bg-accent/10 text-accent text-xs font-medium rounded-full whitespace-nowrap">
            New
          </span>
        )}
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground line-clamp-1">{job?.location}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Briefcase" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground">{job?.type}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="IndianRupee" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground whitespace-nowrap">{job?.stipend}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground">Posted {formatPostedDate(job?.postedDate)}</span>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {job?.skills?.slice(0, 3)?.map((skill, index) => (
          <span 
            key={index}
            className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded-md"
          >
            {skill}
          </span>
        ))}
        {job?.skills?.length > 3 && (
          <span className="px-2 py-1 text-muted-foreground text-xs">
            +{job?.skills?.length - 3} more
          </span>
        )}
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <span className="text-sm text-muted-foreground">
          {job?.applicants} applicants
        </span>
        <Button 
          variant="default" 
          size="sm"
          iconName="Send"
          iconPosition="right"
          onClick={handleApply}
        >
          Apply Now
        </Button>
      </div>
    </div>
  );
};

export default JobRecommendationCard;